import React from 'react';
import { DollarSign } from 'lucide-react';

interface CurrencyInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  isFocused: boolean;
}

export function CurrencyInput({
  label,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  isFocused
}: CurrencyInputProps) {
  const inputClasses = "block w-full pl-12 pr-4 py-4 text-lg rounded-lg border-2 transition duration-200 ease-in-out";
  const labelClasses = "block text-base font-medium text-gray-700 mb-2";
  const iconClasses = "absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5";

  return (
    <div>
      <label htmlFor={name} className={labelClasses}>
        {label}
      </label>
      <div className="relative">
        <DollarSign className={`${iconClasses} text-blue-500`} />
        <input
          type="text"
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className={`${inputClasses} ${
            isFocused
              ? 'border-blue-500 ring-2 ring-blue-200'
              : 'border-gray-200'
          }`}
          placeholder="Enter amount"
        />
      </div>
    </div>
  );
}